import { OrderingField } from '@/models/Filter';

export const createOrderingGuard =
  <T extends string>(fields: readonly T[]) =>
  (value: string | null): value is OrderingField<T> =>
    !!value && fields.some(field => value === field || value === `-${field}`);
